// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2yrUw","colMaxWidth":"Table_colMaxWidth__21XR-"};